/* eslint-disable no-unused-vars,react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import type { Swiper } from 'swiper';
import useData from '@/data/Data.hook';

export interface IHomeSliderData {
  swiper: Swiper | null;
  slideIndex: number;
}

const initialData: IHomeSliderData = {
  swiper: null,
  slideIndex: 0,
};

export const useHomeSliderContext = () => {
  const { query, replace } = useRouter();
  const routeSlideIndex: number = +(query?.index || 0);

  const { data, setData } = useData('homeSlider', { initialData });
  const { swiper, slideIndex } = data!;

  const setSlideData = (args: {
    slideIndex: number;
    speed?: number;
    swiper?: typeof swiper;
  }) => {
    const { speed, ...newData } = args || {};
    try {
      (args?.swiper || swiper)?.slideTo?.(newData.slideIndex, speed);
    } catch (e) {}
    setData(newData);
  };

  const setSwiper = (swiper: Swiper | null) => {
    setSlideData({ swiper, slideIndex: routeSlideIndex, speed: 0 });
  };

  const setSlideIndex = (newSlideIndex: number) => {
    const { index, ...restQuery } = query;
    replace(
      { query: { ...restQuery, index: newSlideIndex } },
      {
        query: {
          ...restQuery,
          // * Show MofidCard section query (?index=1) for analytics
          ...(newSlideIndex !== 0 && { index: newSlideIndex }),
        },
      },
      { shallow: true }
    ).then();
  };

  const setNextSlideIndex = () => {
    const nextSlideIndex: number = (slideIndex + 1) % swiper?.slides?.length!;
    setSlideIndex(nextSlideIndex);
  };

  useEffect(() => {
    if (swiper && routeSlideIndex !== slideIndex) {
      setSlideData({ slideIndex: routeSlideIndex });
    }
  }, [routeSlideIndex]);

  return {
    ...data,
    setSwiper,
    setSlideIndex,
    setNextSlideIndex,
  };
};
